const getBasic = (baseId, orgTimezone) => ({
  description: 'SAMPLE IVR with voicemail after hours and holidays',
  rootNodeId: `blocklist`,
  version: 1,
  id: 'new_configuration_from_template',
  name: 'SAMPLE IVR with voicemail after hours and holidays',
  comment: 'template',
  nodes: [
    {
      type: 'IVR_NODE_VARIABLE',
      ivrNode: {
        id: `blocklist`,
        description: 'List of numbers to block',
        name: 'List of numbers to block',
        expression: '6504756425|6504756426|6504756427',
        nextId: `${baseId}blockCheck`,
        errorNodeId: `${baseId}blockCheck`,
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}qaMessage`,
        name: 'QA Message',
        description: 'QA Message',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/greeting.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        nextId: `${baseId}menu`,
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}smsSent`,
        name: 'SMS Sent',
        description: 'SMS Sent',
        message: {
          message: 'https://s3.amazonaws.com/origin.cdn.gladly.com/orgs/configs/voice/gladly/Sms+sent.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        nextId: '',
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}smsError`,
        name: 'SMS Error',
        description: 'SMS Error',
        message: {
          message: 'https://s3.amazonaws.com/origin.cdn.gladly.com/orgs/configs/voice/gladly/Sms+error.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        nextId: `${baseId}dial`,
      },
    },
    {
      type: 'IVR_NODE_MENU',
      ivrNode: {
        id: `${baseId}menu`,
        name: 'Main Menu',
        description: 'Menu',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/Menu.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        menu: [
          {
            dtmf: '1',
            speech: 'one,1,won,on',
            nextId: `${baseId}sms`,
          },
        ],
        language: 'en-US',
        speechTimeout: 1000000000,
        badSelectionNodeId: `${baseId}dial`,
      },
    },
    {
      type: 'IVR_NODE_SMS',
      ivrNode: {
        id: `${baseId}sms`,
        name: 'Send SMS',
        description: 'Send SMS',
        toNumber: '',
        body: 'Thanks for contacting us! How can we help?',
        nextId: `${baseId}smsSent`,
        errorNodeId: `${baseId}smsError`,
      },
    },
    {
      type: 'IVR_NODE_DIAL',
      ivrNode: {
        id: `${baseId}dial`,
        name: 'Dial',
        description: 'Dial',
        number: '',
        selection: '_dial',
      },
    },
    {
      type: 'IVR_NODE_SCHEDULE',
      ivrNode: {
        id: `${baseId}holidayCheck`,
        name: 'Holiday Check',
        description: 'Holiday Check',
        nodeSchedules: [
          {
            schedule: {
              type: 'SCHEDULE_TYPE_DATE',
              schedule: {
                location: orgTimezone,
                date: '12/25/2019',
                timeRanges: [
                  {
                    start: '00:00',
                    end: '23:59',
                  },
                ],
              },
            },
            nodeId: `${baseId}holidayVoicemail`,
          },
        ],
        defaultNextId: `${baseId}businessHours`,
        defaultOffId: '',
      },
    },
    {
      type: 'IVR_NODE_MENU',
      ivrNode: {
        id: `${baseId}closedVoicemail`,
        name: 'Closed Voicemail Option',
        description: 'Closed Voicemail Option',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/closed-business.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        menu: [
          {
            dtmf: '1',
            speech: '',
            nextId: `${baseId}voicemail`,
          },
        ],
        language: 'en-US',
        speechTimeout: 5000000000,
        badSelectionNodeId: `${baseId}goodbye`,
      },
    },
    {
      type: 'IVR_NODE_SCHEDULE',
      ivrNode: {
        id: `${baseId}businessHours`,
        name: 'Business Hours Check',
        description: 'Business Hours Check',
        nodeSchedules: [
          {
            schedule: {
              type: 'SCHEDULE_TYPE_WEEKDAY',
              schedule: {
                location: orgTimezone,
                daysOfTheWeek: ['Friday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'],
                TimeRanges: [
                  {
                    start: '08:00',
                    end: '17:00',
                  },
                ],
              },
            },
            nodeId: `EDITABLE_${baseId}teamMeeting`,
          },
        ],
        defaultNextId: `${baseId}closedVoicemail`,
        defaultOffId: '',
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}goodbye`,
        name: 'Goodbye',
        description: 'Goodbye',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/silence.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        nextId: '',
      },
    },
    {
      type: 'IVR_NODE_MENU',
      ivrNode: {
        id: `${baseId}holidayVoicemail`,
        name: 'Holiday Voicemail',
        description: 'Holiday Voicemail',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/closed-holiday.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        menu: [
          {
            dtmf: '1',
            speech: '',
            nextId: `${baseId}voicemail`,
          },
        ],
        language: 'en-US',
        speechTimeout: 5000000000,
        badSelectionNodeId: `${baseId}goodbye`,
      },
    },
    {
      type: 'IVR_NODE_VOICEMAIL',
      ivrNode: {
        id: `${baseId}voicemail`,
        name: 'Voicemail',
        description: 'Voicemail',
        selection: '_voicemail',
      },
    },
    {
      type: 'IVR_NODE_VARIABLE_MATCH',
      ivrNode: {
        id: `${baseId}blockCheck`,
        name: 'Block Check',
        description: 'Block Check',
        variableMatches: [
          {
            expression: '{{._customerNumber}}',
            pattern: '/{{.blocklist}}/',
            nextId: `${baseId}goodbye`,
          },
        ],
        defaultNextId: `${baseId}holidayCheck`,
        errorNodeId: `${baseId}holidayCheck`,
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}greeting`,
        name: 'Greeting',
        description: 'Greeting',
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/welcome.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        nextId: `${baseId}qaMessage`,
      },
    },
    {
      type: 'IVR_NODE_MENU',
      ivrNode: {
        id: `${baseId}adhocCloseVoicemailMenu`,
        name: 'ad hoc close voicemail menu',
        description: 'ad hoc close voicemail menu',
        badSelectionNodeId: `${baseId}goodbye`,
        language: 'en-US',
        speechTimeout: 5000000000,
        message: {
          message: 'https://cdn.gladly.com/orgs/configs/voice/gladly/closed-business.mp3',
          type: 'RECORDING',
          language: 'en-US',
          voice: '',
        },
        menu: [
          {
            dtmf: '1',
            speech: '',
            nextId: `${baseId}voicemail`,
          },
        ],
      },
    },
    {
      type: 'IVR_NODE_SCHEDULE',
      ivrNode: {
        id: `EDITABLE_${baseId}teamMeeting`,
        name: 'Ad Hoc Close',
        description: 'Ad Hoc Close',
        nodeSchedules: [],
        defaultNextId: `${baseId}greeting`,
        defaultOffId: `${baseId}adhocCloseVoicemailMenu`,
      },
    },
  ],
  debug: false,
});

export default getBasic;
